var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aviasales"},[_c('app-cells',{attrs:{"position":"between"}},[_c('div',[_c('h1',{staticClass:"title"},[_vm._v("Aviasales")])])]),_c('flight-booking-flow',{attrs:{"can-select":_vm.isGeneralManager}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }